import { MrAdvancedResultsLayoutConfig as boilerplateConfig } from '@net7/boilerplate-muruca';
import { CalderonAdvancedResultsLayoutDS } from '../../layouts/advanced-results-layout/advanced-results-layout.ds';
import * as DS from '../../data-sources';

export const MrAdvancedResultsLayoutConfig = {
  ...boilerplateConfig,
  layoutDS: CalderonAdvancedResultsLayoutDS,
  widgetsDataSources: {
    ...boilerplateConfig.widgetsDataSources,
    ...DS,
  },
};
